/**
 * Access implies - update, delete, read
 * Future version may break down granularity.
 **/
export var Action;
(function (Action) {
    Action[Action["AuthorizeManage"] = 1] = "AuthorizeManage";
    Action[Action["DataAccess"] = 2] = "DataAccess";
    Action[Action["PipeAccess"] = 3] = "PipeAccess";
    Action[Action["SolutionAccess"] = 4] = "SolutionAccess";
    Action[Action["BlueprintAccess"] = 5] = "BlueprintAccess";
    Action[Action["DashboardAccess"] = 6] = "DashboardAccess";
    Action[Action["DashboardManage"] = 7] = "DashboardManage";
    Action[Action["ModuleAccess"] = 8] = "ModuleAccess";
    Action[Action["ModuleManage"] = 9] = "ModuleManage";
    Action[Action["PipeManage"] = 10] = "PipeManage";
    Action[Action["UnitTestDataAccess"] = 11] = "UnitTestDataAccess";
})(Action || (Action = {}));
//# sourceMappingURL=action.js.map